import { render } from "./ClientLogin.vue?vue&type=template&id=b96faa7a&scoped=true"
import script from "./ClientLogin.vue?vue&type=script&lang=js"
export * from "./ClientLogin.vue?vue&type=script&lang=js"

import "./ClientLogin.vue?vue&type=style&index=0&id=b96faa7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96faa7a"]])

export default __exports__